/**
 * Routes pour le module Communication
 * (annonces, emails, campagnes, etc.)
 */

import type { RouteObject } from 'react-router-dom';
import { ProtectedRoute } from '@/app/ProtectedRoute';
import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { AnnouncementView, EmailView } from '@sphere/communication/ui';

const CommunicationPage = lazy(
  () => import('@/pages/Communication/CommunicationPage')
);

export const communicationRoutes: RouteObject[] = [
  {
    path: 'communication',
    element: (
      <ProtectedRoute>
        <CommunicationPage />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <Navigate to="announcements" replace />,
      },
      {
        path: 'announcements',
        element: <AnnouncementView />,
      },
      {
        path: 'emails',
        element: <EmailView />,
      },
    ],
  },
];
